import { useAuthedFetch } from "@/lib/useAuthedFetch";
import { APP_TO_BUILD } from "../../appsConfig";

const f = useAuthedFetch(APP_TO_BUILD);

export interface EmailPreferences {
  questionReports: boolean;
  examReminders: boolean;
  productUpdates: boolean;
}

export const getEmailPreferences = async (): Promise<EmailPreferences> =>
  (await f)<EmailPreferences>("/api/email-preferences", { method: "GET" });

export const updateEmailPreferences = async (
  updates: Partial<EmailPreferences>
): Promise<EmailPreferences> =>
  (await f)<EmailPreferences>("/api/email-preferences", {
    method: "PUT",
    json: updates,
  });
